<template>
    <div>
        <v-card>
          <v-img class="background2" :src="require('../assets/dark parchment background.jpg')">                        
            <v-tabs fixed-tabs v-model="currentClass" background-color="headline brown darken-4" dark class="hidden">
              <img :src="require('../assets/wood boards dark.jpg')" style="background-size:auto!important; position:absolute; width:100%; height:700px">
                <v-tab v-for="className in classes" :key="className" @click="changeTab()" style="font-size:14px">
                  {{classNames[className]}}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="currentClass" style="background:transparent;">
                <v-tab-item v-for="className in classes" :key="className">
                  <div style="border-style:ridge; border-color:saddlebrown;border-width:thick">
                  <v-img class="not-background2 mt-3 mb-4" style="height:200px; text-align:center;" contain :src="require('../assets/lil_bar.png')">
                  <span style="color:white" class="mt-3 mb-4">
                    <v-row style="justify-content:center">
                        <v-col md="2" class="mt-6" style="max-width:325px; min-width:251px">
                          <h2>Account:</h2>
                          <table style="width:100%" v-if="selectedPerks[className] && parseInt(selectedPerks[className].level) >= 0">
                            <tr>
                              <td style="text-align:left">Universal Experience:</td> <td style="padding-left:6px; padding-right:6px">{{selectedPerks.universalExp}}</td>
                            </tr>
                            <tr>
                              
                              <td style="text-align:left">Floor 4 Tokens:</td> <td style="padding-left:6px; padding-right:6px">{{selectedPerks.f4Tokens}}/{{f4TokensRequired[selectedPerks[className].level]}}</td>
                            </tr>
                            <tr >
                              <td style="text-align:left">Floor 6 Tokens</td> <td style="padding-left:6px; padding-right:6px">{{selectedPerks.f6Tokens}}/{{f6TokensRequired[selectedPerks[className].level]}}</td>
                            </tr>
                          </table>
                          <v-btn dark @click="changePerks(currentClass)">Save Changes</v-btn>
                      </v-col>
                      <v-col md="2" class="mt-6" style="max-width:325px; min-width:251px">
                      <h2>{{capitalize(className)}}:</h2>
                      <table style="width:100%" v-if="selectedPerks[className] && parseInt(selectedPerks[className].level) >= 0">
                            <tr >
                              <td style="text-align:left">Level</td> <td style="padding-left:6px; padding-right:6px">{{selectedPerks[className].level}} </td>
                            </tr>
                            <tr>
                              <td style="text-align:left">Class Experience:</td> <td style="padding-left:6px; padding-right:6px">{{selectedPerks[className].exp}} </td>
                            </tr>
                            <tr>
                              <td style="text-align:left">Experience For Next Level:</td> <td style="padding-left:6px; padding-right:6px">{{selectedPerks[className].nextLevel}}</td>
                            </tr>
                        </table>
                        <v-btn dark :disabled="canLevel" @click="levelUp(className)">Level Up</v-btn>
                      </v-col>
                    </v-row>                    
                  </span>
                  <v-overlay :absolute="true" v-model="notFinishedGrab">
                    <v-card>
                      <v-card-title>Getting Account Info</v-card-title>                      
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-card>
                  </v-overlay>
                  </v-img>
                  </div>
                  <div style="overflow-y:scroll; max-height:67vh; overflow-x:hidden;" class="light">
                    <v-img :src="require('../assets/parchment background.jpg')">
                    <v-row v-for="tier in tierNames" :key="tier" class="ma-1">
                      <v-row style="width:100%; justify-content:center; margin-top:16px">
                          <h2 style="align-self:center; color:black;">
                            {{capitalize(tier)}}
                          </h2>                          
                          <span style="align-self:center;" v-if="levelLocked(currentClass, tier)">(Locked) </span>
                      </v-row>
                      <v-row>
                        <v-col v-for="perk in getPerks(classes[currentClass])[tier]" :key="perk.name">
                            <v-card style="background-color:saddlebrown; height:350px" flat >
                              <div v-if="!levelLocked(currentClass, tier)" @click="selectPerk(className, tier, perk.id)" style="height:100%; width:100%; position:absolute; z-index:1" >                                
                              <p></p>
                              </div>
                              <div v-if="levelLocked(currentClass, tier)" style="height:100%; width:100%; position:absolute; z-index:1; display:flex; justify-content:center">
                                <v-icon style="font-size:100px">lock</v-icon>
                              </div>
                              <v-img :src="require('../assets/wood boards dark.jpg')" style="background-size:auto!important; position:absolute; width:100%; height:350px;border-style:outset; border-width:thick;border-color:saddlebrown">
                              <div style="align-items:center; display:flex; flex-direction:column">
                                <v-card-title class="mt-3" :style="`color:${selectedPerks[classes[currentClass]] && selectedPerks[classes[currentClass]][tier] == perk.id ? 'red' : 'white'}; justify-content:center; word-break:break-word`">{{perk.name}}</v-card-title>
                                <v-card-text class="mt-0" style="text-align:center; color:white; max-width:500px; height:210px">{{perk.desc}}</v-card-text>
                                <v-row v-if="!levelLocked(currentClass, tier)" style="justify-content:center;">                                
                                    <div :style="`width:40px;height:40px; border-style:solid;border-color:${selectedPerks[classes[currentClass]] && selectedPerks[classes[currentClass]][tier] == perk.id ? 'red' : 'white'}`">
                                        <v-img class="no-style" v-if="selectedPerks[classes[currentClass]] && selectedPerks[classes[currentClass]][tier] == perk.id" :src="require('../assets/Fight.png')"></v-img>
                                    </div>
                                </v-row>
                                <v-row v-if="!levelLocked(currentClass, tier)" style="justify-content:center">
                                    <span style="color:white" v-if="selectedPerks[classes[currentClass]] && selectedPerks[classes[currentClass]][tier] == perk.id">Selected</span>
                                    <span style="color:white" v-else>Select</span>
                                </v-row>
                              </div>
                              </v-img>
                            </v-card> 
                        </v-col>   
                      </v-row>            
                    </v-row>
                    </v-img>
                  </div>
                    
                </v-tab-item>
            </v-tabs-items>                                        
          </v-img>
        </v-card>
    </div>
</template>

<script>
import {levelUpPerks} from "./data"
export default {
  name: "App",
  data() {
    return {
        classes:["fighter","barbarian","rogue","tank","ranger","monk","warpriest","eldritchKnight","arcaneTrickster","wizard","cleric","shaman","alchemist","sorcerer","prodigy"],
        tierNames:["tier1","tier2","tier3","tier4","tier5","tier6"],
        classNames: {fighter:"Fighter", barbarian:"Barbarian",rogue:"Rogue",tank:"Tank",monk:"Monk",alchemist:"Alchemist",shaman:"Shaman",ranger:"Ranger",warpriest:"Warpriest",eldritchKnight:"Eldritch Knight", arcaneTrickster:"Arcane Trickster",wizard:"Wizard",cleric:"Cleric",sorcerer:"Sorcerer",prodigy:"Prodigy"},
        f4TokensRequired: [0,0,1,3,5,7,999],
        f6TokensRequired: [0,0,0,0,1,3,999],
        tiers:{tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
        url:
        window.location.href == "http://localhost:8080/"
          ? "http://localhost:7071/api/HttpTrigger1"
          : "/api/HttpTrigger1",
          sendExp:"",
          sendf4Tokens:"",
          sendf6Tokens:"",
          className:"",
          currentClass:0,
          selectedPerks:{universalExp:0,f4Tokens:0,f6Tokens:0,
          fighter:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          barbarian:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          rogue:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          tank:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          ranger:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          warpriest:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          eldritchKnight:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          arcaneTrickster:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          wizard:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          cleric:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          sorcerer:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          prodigy:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          monk:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          shaman:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
          alchemist:{exp:0,level:0,nextLevel:50,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0}},
          setFalse:0,
          setTrue:1,
          notFinishedGrab:true,
          changed:false,
    }
  },
  props:{
    email:String,
    password:String,
  },
  mounted(){        
    this.classes.forEach(className=>{
        this.selectedPerks[className] = {level:0,exp:0,nextLevel:0,tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0}
    })
    this.selectedPerks = this.getPlayerDetails()
  },
  computed:{
    canLevel(){
      let className = this.classes[this.currentClass]      
      if(this.selectedPerks.universalExp && this.selectedPerks[className] && this.selectedPerks[className].exp){
        let level = parseInt(this.selectedPerks[className].level)
        if(parseInt(this.selectedPerks.universalExp) + parseInt(this.selectedPerks[className].exp) >= this.selectedPerks[className].nextLevel 
        && this.selectedPerks.f4Tokens >= this.f4TokensRequired[level]
        && this.selectedPerks.f6Tokens >= this.f6TokensRequired[level]){
          return false
        }else{
          return true
        }
      }
      return true
    },
  },
  methods:{
    async getPlayerDetails(){
      this.notFinishedGrab = true
      setTimeout(()=>{
        fetch(this.url, {
          method: "POST",
          body: JSON.stringify({
            command: "getPlayerDetails",
            email:this.email,
            password:this.password
          }),
        }).then(async (response) => {
          let responseText = await response.text()
          console.log("get account response:", responseText)
          
          this.selectedPerks = JSON.parse(responseText)
          console.log(this.selectedPerks)
          this.notFinishedGrab = false
        })
      }, 3000)
    },   

    levelLocked(className, tier){
      if(this.selectedPerks[this.classes[className]]){
        if(parseInt(tier[4]) <= parseInt(this.selectedPerks[this.classes[className]].level)){
          return false
        }else{
          return true
        }                
      }else{
        return true
      }
      
    },

    changePerks(currentClass){
        let className = this.classes[currentClass]
        let tiers = this.selectedPerks[className]
        fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
            command: "changePerks",
            username:this.email,
            password:this.password,
            className,
            tiers,
        }),
      }).then(async (response) => {
        let responseText = await response.text()
        console.log("get account response:", responseText)
      })
    },

    getPerks(className){       
        return levelUpPerks[className]
    },

    selectPerk(className, tier, id){
        this.changed = true
        this.selectedPerks[className][tier] = parseInt(id)
    },
    
    levelUp(currentClass){
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
            command: "levelUp",
            username:this.email,
            password:this.password,
            className:currentClass,
            
        }),
      }).then(async (response) => {
        let responseText = await response.text()
        console.log("get account response:", responseText)
        this.getPlayerDetails()
      })
    },

    capitalize(str){  
      for(let x = 0; x < str.length; x++){
        if(str[x].toUpperCase() == str[x]){
          str = str.substring(0,x) + " " + str.substring(x,str.length)
          break;
        }
      }            
      let newStr = str[0].toUpperCase() + str.substring(1)
      return newStr
    },

    changeTab(){
      if(this.changed){
        this.changePerks(this.currentClass)
        this.changed = false
      }
    }
  }
}

</script>
<style >
.background2 .v-image__image{
  background-repeat: round;
  background-size: contain !important; 
}
.background2 .not-background .v-image__image{
  background-repeat: no-repeat;
  background-size: cover !important; 
}
.not-background2 .v-image__image{
  background-size: contain !important; 
  background-repeat: no-repeat !important;
}
.light::-webkit-scrollbar {
  width: 8px;
}

.light::-webkit-scrollbar-track {
  background: rgb(0,0,0,0);
}

.light::-webkit-scrollbar-thumb {
  background: rgb(62,39,35);  
  border-radius: 7px;
}

.light .v-input__slot::-webkit-scrollbar{
  width: 8px;
}
.hidden .v-slide-group__prev{
  display:none!important;
}
</style>
